import { executeGet, executePut } from '../common/apiCaller'
import {
  GetChildrenTreatmentDto,
  PutChildrenTreatmentInputDto,
} from '../dto/childrenTreatmentDto'

const apiName = 'public'
const apiPath = '/children-treatment'

// 治療情報取得
export const executeGetChildrenTreatment = (id: string, facilityId: string) => {
  return executeGet<GetChildrenTreatmentDto[]>(apiName, `${apiPath}/${id}`, { facilityId })
}

// 治療情報登録
export const executePutChildrenTreatment = (id: string, input: PutChildrenTreatmentInputDto) => {
  return executePut<null>(apiName, `${apiPath}/${id}`, input)
}